<div class="section" *ngFor="let section of instructionSections">
    <h4 class="offset-left narrow headline">{{ section.instructionHeading }}</h4>
    <ng-container *ngFor="let step of section.instructionList; let i = index">
        <div class="offset-left step" [ngClass]="{ 'step_no-tip': !step.tipText, 'step_done': step.stepDone }">
            <button
                type="button"
                class="step__counter display-6"
                [ngClass]="{ counter_done: step.stepDone }"
                (click)="step.stepDone = !step.stepDone"
            >
                <app-svg-icon *ngIf="step.stepDone" iconName="tick"></app-svg-icon>
                <span *ngIf="!step.stepDone">{{ i + 1 }}</span>
            </button>
            <div class="step__content" [ngClass]="{ content_done: step.stepDone }">
                <div class="narrow display-6">
                    {{ step.text }}
                </div>
                <div class="image-wrapper" *ngFor="let image of step.images">
                    <app-image [image]="image" [height]="327" [style]="{ width: 'auto' }"></app-image>
                </div>
            </div>
        </div>
        <div class="tip" *ngIf="step.tipText">
            <span class="display-1 handwriting">
                {{ 'recipe.tip' | translateSafe }}
            </span>
            <span class="tip-text display-quote">
                {{ step.tipText }}
            </span>
        </div>
    </ng-container>
</div>
